import { useTranslate } from "@tolgee/react";
import { useAtomValue } from "jotai";
import { ChevronRight } from "lucide-react";
import { LocalizedLink } from "#/components/locale/localized-link";
import type { Post } from "#/lib/api/posts";
import type { SupportedLocale } from "#/lib/locale";
import { localeAtom } from "#/stores/locale-store";

const NO_RESULTS: Record<SupportedLocale, string> = {
	en: "No results found.",
	ko: "검색 결과가 없습니다.",
	zh: "没有找到结果。",
};

type LearnSearchResultsProps = {
	matches: readonly Post[];
	hasResults: boolean;
};

export function LearnSearchResults({
	matches,
	hasResults,
}: LearnSearchResultsProps) {
	const { t } = useTranslate();
	const locale = useAtomValue(localeAtom);

	if (!hasResults) {
		return (
			<p className="py-8 text-center text-body2 text-muted-foreground">
				{NO_RESULTS[locale] ?? NO_RESULTS.en}
			</p>
		);
	}

	return (
		<ul className="flex flex-col">
			{matches.map((post) => (
				<li key={post.slug} className="border-b border-border last:border-b-0">
					<LocalizedLink
						to="/learn/$slug"
						params={{ slug: post.slug }}
						className="flex items-start justify-between gap-3 px-4 py-3 text-body2-medium text-foreground transition-colors hover:bg-muted/50"
					>
						<div className="flex flex-col gap-1">
							<span className="whitespace-pre-line">{post.title}</span>
							<span className="text-label2 text-muted-foreground">
								{t(`learn.section.${post.category}`)}
							</span>
						</div>
						<ChevronRight className="mt-0.5 h-4 w-4 shrink-0 text-muted-foreground" />
					</LocalizedLink>
				</li>
			))}
		</ul>
	);
}
